import { MusicNoteIcon as PhosphorMusicNoteIcon } from "@phosphor-icons/react/dist/ssr/MusicNote";

import { createAppIcon } from "@/components/createAppIcon";

export const MusicIcon = /* @__PURE__ */ createAppIcon(PhosphorMusicNoteIcon);
